<template>
	<modal
		:min-width="modalOptions.largura"
		:min-height="modalOptions.altura"
		:exibir="exibir"
		:custom-actions="true"
		:titulo="tituloModal"
		@close="fecharModal"
		:acao-cancelar="fecharModal"
		classe-personalizada-body="padding-body"
		:is-confirmar-visivel="true"
	>
		<template #body>
			<az-container class="mt-0">
				<listagem-itens
					ref="listagemItensPenalidades"
					:textos-do-template-da-listagem-vazia="textosDaListagemVazia"
					:colunas="getColunas()"
					:itens="itensDatasource"
					:total-paginas="itensTotalPaginas"
					:total-itens="totalItens"
					:custom-columns="['dataCadastro', 'numero', 'doe']"
					:paginacao="paginacao"
					@paginar="setPaginacao"
					@resetar-page="resetarPaginaListagem()"
					@linha-clicada="redirecionaAditivoApostila"
					:tamanho-maximo-colunas="tamanhoMaximoColunas"
				>
					<template #numero="{ item }">
						<span>{{ formatarNumero(item.numero) }}</span>
					</template>

					<template #doe="{ item }">
						<texto-tooltip
							:texto="formatarTexto(item.doe)"
							:tamanho-maximo="50"
						></texto-tooltip>
					</template>

					<template #dataCadastro="{ item }">
						<span>{{ item.dataCadastro | formatDataFilter }}</span>
					</template>
				</listagem-itens>
			</az-container>
		</template>
	</modal>
</template>
<script>
import Modal from '@/views/components/Modal'
import BotaoCancelar from '@/views/components/BotaoCancelar'
import BotaoPrimario from '@/views/components/BotaoPrimario'
import LabelPersonalizado from '@/views/components/LabelPersonalizado'
import InputTextDeData from '@/views/components/input/InputTextDeData'
import validacaoFormulario from '@/views/mixins/validacaoFormulario'
import {actionTypes, routesNames} from '@/core/constants'
import {TabelaColunaUtils} from '@/core/utils'
import paginacaoListagem from '@/core/store/default/paginacaoListagem'
import ListagemItens from '@/views/components/ListagemItens'
import IconeTooltip from '@/views/components/IconeTooltip'
import TextoTooltip from '@/views/components/TextoTooltip'
import {mapState} from 'vuex'

export default {
	name: 'modal-historico-aditivo-apostila',
	components: {
		TextoTooltip,
		IconeTooltip,
		ListagemItens,
		InputTextDeData,
		LabelPersonalizado,
		BotaoPrimario,
		BotaoCancelar,
		Modal,
	},
	mixins: [validacaoFormulario],
	props: {
		exibir: {
			type: Boolean,
		},
		modalOptions: {
			type: Object,
			default: () => {
				return { largura: '50%', altura: '80%' }
			},
		},
		idAta: {
			type: [String, Number],
			required: true,
		},
		tituloModal: {
			type: String,
			default: () => 'Histórico Aditivo/Apostila',
		},
		textosDaListagemVazia: {
			type: Object,
			default: () => {
				return { titulo: 'Nenhum item por aqui' }
			},
		},
	},
	emits: ['fechar-modal', 'confirmar', 'salvar-dados-gerais'],
	data() {
		return {
			isFormValid: false,
			itensDatasource: [],
			itensTotalPaginas: 0,
			totalItens: 0,
			paginacao: paginacaoListagem('id', 25, 'ASC'),
			tamanhoMaximoColunas: {
				numero: 80,
				dataCriacao: 80,
				usuario: 80,
			},
		}
	},
	computed: {
		...mapState({
			infoAta: (state) => state.ata.informacoesAta,
		}),
	},
	async mounted() {
		await this.buscarInformacoes()
	},
	methods: {
		async buscarInformacoes() {
			const { itens, totalElements, totalPages } = await this.$store.dispatch(
				actionTypes.ADITIVO_APOSTILA.BUSCAR_HISTORICO_ADITIVO_APOSTILA,
				{
					paginacao: this.paginacao,
					idAta: this.idAta,
				},
			)
			this.itensDatasource = itens
			this.totalItens = totalElements
			this.itensTotalPaginas = totalPages
		},
		async redirecionaAditivoApostila(item) {
			await this.$router.push({
				name: routesNames.ATA.ATA_ACESSAR_ADITIVO_APOSTILA_VIEW,
				params: { id: this.$route.params.id, idAditivoApostila: item.id },
			})
		},
		async resetarPaginaListagem() {
			this.paginacao.page = 1
			await this.buscarInformacoes()
		},
		async setPaginacao(paginacao) {
			this.paginacao = paginacao
			await this.buscarInformacoes()
		},
		getColunas() {
			return [
				new TabelaColunaUtils('Número', 'numero', '23%'),
				new TabelaColunaUtils('DOE', 'doe', '20%'),
				new TabelaColunaUtils('Data Criação', 'dataCadastro', '23%'),
				new TabelaColunaUtils('Usuário', 'usuario', '34%'),
			]
		},
		formatarTexto(valor) {
			return (!valor || !valor.trim()) ? '---' : valor
		},
		fecharModal() {
			this.$emit('fechar-modal')
		},
		formatarNumero(numero) {
			return numero ? numero : 'Não informado'
		},
	},
}
</script>

<style lang="stylus">
.bg-white
	background-color white

.padding-body
	padding 0 !important

.v-dialog--active:has(.hidden-overflow)
	overflow hidden !important

.padding-right-14
	padding-right 14px

.background-color
	background-color #F2F7FA
</style>
